import React from "react";

import { IconButton } from "@mui/material";
import Tooltip from "../../../../../components/Tooltip";
// hooks
import useAuth from "../../../../../hooks/useAuth";
import Mnemonic from "../../../../../Mnemonics.json"
//translation
import { useTranslation } from "react-i18next";

const EditRecord = (props) => {
  const {
    timeEntryGuid,
    synced,
    description,
    handleClick,
    handleEditMode,
    handleRowSelect,
    handleChangeTask,
    task,
    employee,
    timeEntryStatus,
    isEditable,
    timeSheetGuid,
    fromTimeEntryApproval
  } = props;

  const { t } = useTranslation();
  const { storeUserGuid, storeUserTenant, isManager, userRoles } = useAuth();
  const { isAdmin, manageTimeEntry } = userRoles;

  const handleEditClick = () => {
    
    
    handleClick(true);
    if(handleChangeTask) handleChangeTask(task);
    handleEditMode(true);
    const obj = {
      timeEntryGuid: timeEntryGuid,
      description: description,
      synced: synced,
      disabled:(!isEditable && fromTimeEntryApproval!==true)
      || synced
         ||
        ( timeEntryStatus?.mnemonic === Mnemonic.TimeEntryStatuses.Approved && timeSheetGuid!==null)// add  && if timsheet guid !=null
        
    };
    handleRowSelect(obj);
  };

  if (!timeEntryGuid) return null;
 
  return (
    <>
      <Tooltip 
  title={
    ((!isEditable && fromTimeEntryApproval!==true) || synced || ( timeEntryStatus?.mnemonic === Mnemonic.TimeEntryStatuses.Approved  && timeSheetGuid!==null))
      ? synced
        ? t("tooltip.timeEntry.Synced")
        :( timeEntryStatus?.mnemonic === Mnemonic.TimeEntryStatuses.Approved  && timeSheetGuid!==null)// add && if timsheet guid !=null
        ? t("tooltip.timeEntry.Approved")
        : t("tooltip.timeEntry.cannotManageTimeEntry")
      : t("timeEntry.info")
  } 
  disableInteractive
>
  {/* Wrap IconButton inside a span to show tooltip even when disabled */}
  <span>
    <IconButton  
      // disabled={(!isEditable && fromTimeEntryApproval!==true)|| synced
      //    ||
      //   ( timeEntryStatus?.mnemonic === Mnemonic.TimeEntryStatuses.Approved && timeSheetGuid!==null)// add  && if timsheet guid !=null
      //   } 
      onClick={handleEditClick} 
      className="timeSheetCol"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-dots"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        strokeWidth="1"
        stroke="#000000"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        <path d="M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      </svg>
    </IconButton>
  </span>
</Tooltip>

    </>
  );
};

export default EditRecord;
